import { Dispatch } from '@reduxjs/toolkit';
import { CLICKSTREAM_EVENT_NAMES } from 'src/service/clickStream.constant';
import { addClickstreamEvent } from 'src/service/clickStreamEventService';
import axiosInstance, { ApiKeys, getApiUrl, logError } from 'src/utils/ApiHelper';
import {
  setAgentAvailabilityLists,
  setAgentAvailablityHistoryData,
  setApiResponse,
  setHistoryLoading,
  setLoading,
  clearAgentAvailabilityData
} from '../reducers';
import { getFileDownload, getMultipleFileDownload } from '@cp/src/utils/commonUtils';
import { toast } from '@primitives/Toast';
import { ToastMessage } from './utils';

export const getAgentAvailabilityData = (agentReferenceId: string) => (dispatch: Dispatch) => {
  dispatch(clearAgentAvailabilityData());
  dispatch(setLoading(true));
  const url = getApiUrl(ApiKeys.AGENT_AVAILABILITY, { agentReferenceId });
  const startTime = Date.now();
  axiosInstance
    .get(url, { headers: { includeInUptimeMetrics: true } })
    .then(response => {
      const endTime = Date.now();
      addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.AGENT_AVAILABILITY_API_RESPONSE, {
        timeTaken: endTime - startTime
      });
      if (response.data) {
        dispatch(setApiResponse({ ...response.data, response: 'success' }));
      }
    })
    .catch(e => {
      logError(e, 'Error fetching agent availability data');
    })
    .finally(() => {
      setTimeout(() => {
        dispatch(setLoading(false));
      }, 300);
    });
};

export const getAvailabilityHistoryData =
  (startDate: string, agentReferenceId: string) => (dispatch: Dispatch) => {
    dispatch(setHistoryLoading(true));
    const url = getApiUrl(ApiKeys.AGENT_AVAILABILITY_HISTORY, { agentReferenceId });

    axiosInstance
      .get(url, { params: { startDate: startDate }, headers: { includeInUptimeMetrics: true } })
      .then(response => {
        if (response.data) {
          dispatch(setAgentAvailablityHistoryData({ ...response.data, response: 'success' }));
        }
      })
      .catch(error => {
        logError(error, 'Error fetching agent availability history data');
      })
      .finally(() => {
        dispatch(setHistoryLoading(false));
      });
  };

export const downloadAgentAvailabilityHistory = ({
  tlRefId,
  agentRefId,
  radioOption
}: {
  tlRefId?: string;
  agentRefId?: string;
  radioOption?: string;
}) => {
  const url = getApiUrl(ApiKeys.AGENT_AVAILABILITY_HISTORY_DOWNLOAD);
  axiosInstance
    .get(url, { params: { tlRefId, agentRefId } })
    .then(response => {
      if (response.data) {
        toast(ToastMessage, { type: 'success' });
        if (radioOption === 'All') {
          getMultipleFileDownload([
            response.data.loginTimeFileUrl,
            response.data.activeMinutesFileUrl
          ]);
        } else if (radioOption === 'ActiveHrs') {
          getFileDownload(response.data.activeMinutesFileUrl);
        } else {
          getFileDownload(response.data.loginTimeFileUrl);
        }
      }
    })
    .catch(error => {
      toast.error('Error downloading agent availability history');
    });
};

export const fetchAgentAvailabilityLists = () => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.AGENT_AVAILABILITY_DETAILS);
  axiosInstance
    .get(url, { headers: { includeInUptimeMetrics: true } })
    .then(response => {
      if (response.data) {
        dispatch(setAgentAvailabilityLists(response.data));
      }
    })
    .catch(error => {
      logError(error, 'Error fetching agent availability lists');
    });
};
